var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27 7v4a13.015 13.015 0 0 0 -9 12.745 8.512 8.512 0 0 0 1 4.255l1.649 3.3a1.086 1.086 0 0 1 -.2 1.254l-1.524 1.524a1.086 1.086 0 0 0 -.146 1.355l1.291 2.014a1.089 1.089 0 0 1 -.131 1.339l-.916.955a1.1 1.1 0 0 0 .286 1.744l1.936 1.009a.814.814 0 0 1 .125 1.363l-2.62 2.049a1.978 1.978 0 0 0 -.75 1.558v6.762a4.625 4.625 0 0 0 4.2 4.774 4.313 4.313 0 0 0 3.978-2.351 4.273 4.273 0 0 0 7.636 0 4.313 4.313 0 0 0 3.986 2.351 4.625 4.625 0 0 0 4.2-4.774v-8.407a4.39 4.39 0 0 0 -.63-2.348 2.351 2.351 0 0 1 -.37-1.271v-2.157a1.124 1.124 0 0 0 -.308-.776l-2.311-2.236a1.131 1.131 0 0 1 0-1.552l2.761-2.879a1.128 1.128 0 0 0 -.113-1.654l-2.675-2.264a.948.948 0 0 1 -.04-1.411l3.365-3.193a1.148 1.148 0 0 0 .315-.814 12.958 12.958 0 0 0 -8.994-12.264v-4z",
    fill: "#d7e9fd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m27 1h6a2 2 0 0 1 2 2v4a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1-1v-4a2 2 0 0 1 2-2z",
    fill: "#4078bc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#c3ddf4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27 43a1 1 0 0 1 -.123-1.992l8-1a1 1 0 1 1 .248 1.984l-8 1a1.063 1.063 0 0 1 -.125.008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 28a1 1 0 0 1 -.287-1.958l10-3a1 1 0 1 1 .574 1.916l-10 3a1.023 1.023 0 0 1 -.287.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 36a.948.948 0 0 1 -.2-.02l-5-1a1 1 0 1 1 .392-1.96l5 1a1 1 0 0 1 -.192 1.98z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottle);
export default __webpack_public_path__ + "static/media/bottle.b41f35bf62014f8a7160bc0293cc89c5.svg";
export { ForwardRef as ReactComponent };